import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Container,
  Grid,
  Paper,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  // Tooltip, // Kullanılmıyor
  IconButton,
  Stack,
  Button,
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // TextField, // Kullanılmıyor
  Avatar,
  CircularProgress,
  FormControlLabel,
  Switch,
  ButtonGroup, // ButtonGroup import edildi
  List,
  ListItem, 
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  ComposedChart,
  Area,
  // Scatter, // Kullanılmıyor
  Brush,
  ReferenceLine
} from 'recharts';
// import RefreshIcon from '@mui/icons-material/Refresh'; // Kullanılmıyor
import BarChartIcon from '@mui/icons-material/BarChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; // Kullanılmıyor
import StorefrontIcon from '@mui/icons-material/Storefront';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InsightsIcon from '@mui/icons-material/Insights';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AnimatedNumber from '../../components/common/AnimatedNumber';
import TuneIcon from '@mui/icons-material/Tune';
import FilterListIcon from '@mui/icons-material/FilterList';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DoneIcon from '@mui/icons-material/Done';
import InfoIcon from '@mui/icons-material/Info';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Checkbox from '@mui/material/Checkbox';

// Renk paleti
const COLORS = ['#3f51b5', '#2196f3', '#4caf50', '#ff9800', '#f44336', '#9c27b0', '#e91e63', '#00bcd4'];

// Örnek satış tahmin verileri
const generateSalesData = () => {
  // Son 24 aylık veri
  const data = [];
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentYear = now.getFullYear();
  
  // Mevsimsellik faktörleri (aylara göre)
  const seasonalFactors = [0.85, 0.9, 1.0, 1.05, 1.1, 1.15, 1.2, 1.25, 1.15, 1.1, 1.3, 1.5];
  
  // Temel aylar, son 24 ay
  for (let i = 0; i < 24; i++) {
    const monthOffset = i - 23; // -23, -22, ..., -1, 0 (şimdiki ay)
    const month = (currentMonth + monthOffset) % 12;
    const year = currentYear + Math.floor((currentMonth + monthOffset) / 12);
    const monthName = new Date(year, month, 1).toLocaleString('tr-TR', { month: 'short' });
    
    const actualMonth = month >= 0 ? month : month + 12;
    const seasonality = seasonalFactors[actualMonth];
    
    // Genel artış trendi ve mevsimsellik
    const baseSales = 800000 + i * 15000;
    const actualSales = Math.round(baseSales * seasonality + (Math.random() * 50000 - 25000));
    
    // Öngörülen satışlar (biraz sapma ile)
    const forecastSales = Math.round(actualSales * (0.9 + Math.random() * 0.2));
    
    // Tahmin varyansı (güven aralığı için)
    const variance = Math.round(actualSales * 0.1);
    
    // Ürün kategorilerine göre satışlar
    const electronicsSales = Math.round(actualSales * 0.4);
    const clothingSales = Math.round(actualSales * 0.3);
    const homeSales = Math.round(actualSales * 0.2);
    const otherSales = actualSales - electronicsSales - clothingSales - homeSales;
    
    // Kar marjı
    const profitMargin = 15 + Math.random() * 10;
    const profit = Math.round(actualSales * (profitMargin / 100));
    
    data.push({
      id: i,
      date: `${monthName} ${year}`,
      month: monthName,
      year: year,
      actual: actualSales,
      forecast: i >= 18 ? forecastSales : null, // Son 6 aydan önce tahmin yok
      upper: i >= 18 ? forecastSales + variance : null,
      lower: i >= 18 ? forecastSales - variance : null,
      electronics: electronicsSales,
      clothing: clothingSales,
      home: homeSales,
      other: otherSales,
      profit: profit,
      profitMargin: profitMargin.toFixed(1)
    });
  }
  
  // Gelecek 12 ay için tahmin
  for (let i = 1; i <= 12; i++) {
    const monthOffset = i;
    const month = (currentMonth + monthOffset) % 12;
    const year = currentYear + Math.floor((currentMonth + monthOffset) / 12);
    const monthName = new Date(year, month, 1).toLocaleString('tr-TR', { month: 'short' });
    
    const actualMonth = month >= 0 ? month : month + 12;
    const seasonality = seasonalFactors[actualMonth];
    
    // Gelecek ay tahminleri, son 6 aydakiyle aynı trend
    const baseSales = 800000 + (23 + i) * 15000;
    const forecastSales = Math.round(baseSales * seasonality);
    
    // Tahmin varyansı (güven aralığı için)
    const variance = Math.round(forecastSales * (0.05 + (i * 0.01))); // Zaman ilerledikçe varyans artar
    
    // Ürün kategorilerine göre tahminler
    const electronicsSales = Math.round(forecastSales * 0.4);
    const clothingSales = Math.round(forecastSales * 0.3);
    const homeSales = Math.round(forecastSales * 0.2);
    const otherSales = forecastSales - electronicsSales - clothingSales - homeSales;
    
    // Tahmini kar marjı
    const profitMargin = 15 + Math.random() * 10;
    const profit = Math.round(forecastSales * (profitMargin / 100));
    
    data.push({
      id: 24 + i - 1,
      date: `${monthName} ${year}`,
      month: monthName,
      year: year,
      actual: null, // Gelecek için gerçek veri yok
      forecast: forecastSales,
      upper: forecastSales + variance,
      lower: forecastSales - variance,
      electronics: electronicsSales,
      clothing: clothingSales,
      home: homeSales,
      other: otherSales,
      profit: profit,
      profitMargin: profitMargin.toFixed(1)
    });
  }
  
  return data;
};

// Özet metrikler
const calculateSummaryMetrics = (data) => {
  // Son 6 aylık gerçek veriler
  const last6Months = data.slice(18, 24).filter(item => item.actual !== null);
  // Gelecek 6 aylık tahminler
  const next6Months = data.slice(24, 30);
  
  // Son 6 ay toplamı
  const last6MonthsTotal = last6Months.reduce((sum, item) => sum + item.actual, 0);
  // Gelecek 6 ay toplamı
  const next6MonthsTotal = next6Months.reduce((sum, item) => sum + item.forecast, 0);
  
  // Büyüme oranı
  const growthRate = ((next6MonthsTotal - last6MonthsTotal) / last6MonthsTotal) * 100;
  
  // Ortalama tahmin doğruluğu (son 6 ay için gerçek vs tahmin)
  const accuracySum = last6Months.reduce((sum, item, index) => {
    if (item.forecast) {
      const accuracy = 100 - Math.abs(((item.forecast - item.actual) / item.actual) * 100);
      return sum + accuracy;
    }
    return sum;
  }, 0);
  const avgAccuracy = accuracySum / last6Months.length;
  
  // En yüksek satış ayı (gelecek)
  const highestMonth = [...next6Months].sort((a, b) => b.forecast - a.forecast)[0];
  
  // En büyük büyüme kategorisi
  const categories = ['electronics', 'clothing', 'home', 'other'];
  const categoryGrowth = categories.map(category => {
    const lastTotal = last6Months.reduce((sum, item) => sum + item[category], 0);
    const nextTotal = next6Months.reduce((sum, item) => sum + item[category], 0);
    const growth = ((nextTotal - lastTotal) / lastTotal) * 100;
    return { category, growth };
  });
  
  const topGrowthCategory = categoryGrowth.sort((a, b) => b.growth - a.growth)[0];
  
  return {
    currentMonthSales: last6Months[5].actual, // Son ay
    nextMonthForecast: next6Months[0].forecast, // Gelecek ay
    growthRate: growthRate.toFixed(1),
    forecastAccuracy: avgAccuracy.toFixed(1),
    highestMonth: {
      month: highestMonth.month,
      year: highestMonth.year,
      forecast: highestMonth.forecast
    },
    topGrowthCategory: {
      name: topGrowthCategory.category,
      growth: topGrowthCategory.growth.toFixed(1)
    }
  };
};

// Tahmin modelleri performansı
const forecastModels = [
  { id: 1, name: 'ARIMA', accuracy: 92.5, mape: 7.5, complexity: 'Orta', trainingTime: '2m 35s' },
  { id: 2, name: 'Prophet', accuracy: 94.2, mape: 5.8, complexity: 'Düşük', trainingTime: '1m 45s' },
  { id: 3, name: 'LSTM', accuracy: 95.8, mape: 4.2, complexity: 'Yüksek', trainingTime: '15m 20s' },
  { id: 4, name: 'XGBoost', accuracy: 93.7, mape: 6.3, complexity: 'Orta', trainingTime: '3m 10s' },
  { id: 5, name: 'ETS', accuracy: 91.3, mape: 8.7, complexity: 'Düşük', trainingTime: '1m 20s' }
];

// Kategori renkleri
const categoryColors = {
  electronics: '#3f51b5',
  clothing: '#4caf50',
  home: '#ff9800',
  other: '#e91e63'
};

// Etkileyen faktörler
const influencingFactors = [
  { factor: 'Mevsimsellik', impact: 35, description: 'Mevsimsel değişimler satışları önemli ölçüde etkiliyor. Özellikle Kasım-Aralık aylarında yüksek artış.' },
  { factor: 'Promosyonlar', impact: 25, description: 'İndirim kampanyaları satışlarda ortalama %25 artışa neden oluyor.' },
  { factor: 'Ekonomik Göstergeler', impact: 20, description: 'Enflasyon ve döviz kurlarındaki değişimler tüketici davranışlarını etkiliyor.' },
  { factor: 'Ürün Lansmanları', impact: 15, description: 'Yeni ürün lansmanları ilgili kategorilerde geçici artışlar sağlıyor.' },
  { factor: 'Hava Durumu', impact: 5, description: 'Özellikle giyim kategorisinde mevsim geçişlerinde etkili.' }
];

// Feature listesi - tahmin modeli için kullanılabilecek özellikler
const salesFeatures = [
  { 
    id: 'historical', 
    name: 'Geçmiş Satışlar', 
    description: 'Geçmiş dönemlerdeki satış verilerini kullanır',
    impact: 'high', 
    default: true,
    category: 'temel'
  },
  { 
    id: 'seasonality', 
    name: 'Mevsimsellik', 
    description: 'Yıl içindeki mevsimsel dalgalanmaları hesaba katar',
    impact: 'high', 
    default: true,
    category: 'temel'
  },
  { 
    id: 'trend', 
    name: 'Trend Analizi', 
    description: 'Uzun vadeli satış eğilimlerini analiz eder',
    impact: 'medium', 
    default: true,
    category: 'temel'
  },
  { 
    id: 'price', 
    name: 'Fiyat Değişimleri', 
    description: 'Ürün fiyatlarındaki değişimlerin etkisini hesaplar',
    impact: 'high', 
    default: true,
    category: 'temel'
  },
  { 
    id: 'promotions', 
    name: 'Promosyonlar', 
    description: 'Kampanya ve promosyonların satışlar üzerindeki etkisini analiz eder',
    impact: 'high', 
    default: true,
    category: 'pazarlama'
  },
  { 
    id: 'marketing', 
    name: 'Pazarlama Harcamaları', 
    description: 'Reklam ve pazarlama bütçesinin satışlara etkisini ölçer',
    impact: 'medium', 
    default: true,
    category: 'pazarlama'
  },
  { 
    id: 'weather', 
    name: 'Hava Durumu', 
    description: 'Hava koşullarının satışlar üzerindeki etkisini analiz eder',
    impact: 'medium', 
    default: false,
    category: 'dış faktörler'
  },
  { 
    id: 'economic', 
    name: 'Ekonomik Göstergeler', 
    description: 'Enflasyon, döviz kuru gibi makroekonomik faktörleri hesaba katar',
    impact: 'medium', 
    default: false,
    category: 'dış faktörler'
  },
  { 
    id: 'competitor', 
    name: 'Rakip Analizi', 
    description: 'Rakiplerin fiyat ve kampanyalarının etkisini analiz eder',
    impact: 'medium', 
    default: false,
    category: 'dış faktörler'
  },
  { 
    id: 'stockLevel', 
    name: 'Stok Seviyeleri', 
    description: 'Stok durumu ve tedarik zinciri etkilerini analiz eder',
    impact: 'low', 
    default: false,
    category: 'tedarik'
  },
  { 
    id: 'social', 
    name: 'Sosyal Medya Trendleri', 
    description: 'Sosyal medya etkileşimlerinin satışlara etkisini ölçer',
    impact: 'low', 
    default: false,
    category: 'pazarlama'
  },
  { 
    id: 'events', 
    name: 'Özel Gün ve Etkinlikler', 
    description: 'Bayram, yılbaşı, okul başlangıcı gibi özel dönemlerdeki etkileri analiz eder',
    impact: 'high', 
    default: true,
    category: 'temel'
  },
  { 
    id: 'crossSelling', 
    name: 'Çapraz Satış Analizi', 
    description: 'Ürünler arasındaki satış ilişkilerini analiz eder',
    impact: 'medium', 
    default: false,
    category: 'ürün'
  },
  { 
    id: 'customerSegments', 
    name: 'Müşteri Segmentleri', 
    description: 'Farklı müşteri gruplarının satın alma davranışlarını analiz eder',
    impact: 'medium', 
    default: false,
    category: 'müşteri'
  },
  { 
    id: 'productLifecycle', 
    name: 'Ürün Yaşam Döngüsü', 
    description: 'Ürünlerin pazar yaşam eğrisindeki konumunu hesaba katar',
    impact: 'low', 
    default: false,
    category: 'ürün'
  }
];

// Senaryolar - önceden hazırlanmış feature kombinasyonları
const forecastScenarios = [
  {
    id: 'basic',
    name: 'Temel Tahmin',
    description: 'Temel satış tahmin modelidir, sadece geçmiş veriler ve mevsimsel etkileri kullanır',
    features: ['historical', 'seasonality', 'trend'],
    accuracy: 87.5
  },
  {
    id: 'advanced',
    name: 'Gelişmiş Tahmin',
    description: 'Pazarlama faktörlerini ve ekonomik göstergeleri de hesaba katan gelişmiş model',
    features: ['historical', 'seasonality', 'trend', 'price', 'promotions', 'marketing', 'events'],
    accuracy: 92.3
  },
  {
    id: 'premium',
    name: 'Premium Tahmin',
    description: 'Tüm faktörleri hesaba katan en kapsamlı ve doğru tahmin modeli',
    features: ['historical', 'seasonality', 'trend', 'price', 'promotions', 'marketing', 'weather', 'economic', 'competitor', 'events', 'customerSegments'],
    accuracy: 95.8
  },
  {
    id: 'eCommerce',
    name: 'E-Ticaret Odaklı',
    description: 'Online satış kanalları için özelleştirilmiş tahmin modeli',
    features: ['historical', 'seasonality', 'price', 'promotions', 'marketing', 'social', 'events', 'crossSelling'],
    accuracy: 93.7
  },
  {
    id: 'retail',
    name: 'Perakende Odaklı',
    description: 'Fiziksel mağazalar için özelleştirilmiş tahmin modeli',
    features: ['historical', 'seasonality', 'trend', 'price', 'weather', 'events', 'stockLevel'],
    accuracy: 91.4
  }
];

// Ana Bileşen
const SatisTahinleme = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [salesData, setSalesData] = useState([]);
  const [summaryMetrics, setSummaryMetrics] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedModel, setSelectedModel] = useState('Prophet');
  const [forecastRange, setForecastRange] = useState('6month');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [confidenceInterval, setConfidenceInterval] = useState(true);
  const [modellingProgress, setModellingProgress] = useState(0);
  const [isTrainingModel, setIsTrainingModel] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState('advanced');
  const [enabledFeatures, setEnabledFeatures] = useState(() => {
    // Varsayılan olarak advanced senaryo özelliklerini kullan
    const scenario = forecastScenarios.find(s => s.id === 'advanced');
    return scenario ? scenario.features : [];
  });
  const [featureDialogOpen, setFeatureDialogOpen] = useState(false);
  const [scenarioDialogOpen, setScenarioDialogOpen] = useState(false);
  const [comparisonMode, setComparisonMode] = useState(false);
  const [comparisonScenario, setComparisonScenario] = useState('basic');
  const [comparisonData, setComparisonData] = useState([]);
  const [isCustomScenario, setIsCustomScenario] = useState(false);
  
  // Veri yükleme simülasyonu
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const data = generateSalesData();
      setSalesData(data);
      setSummaryMetrics(calculateSummaryMetrics(data));
      setLoading(false);
    }, 1200);
  }, []);
  
  // Tab değişimi
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  // Model seçimi değişimi
  const handleModelChange = (event) => {
    setSelectedModel(event.target.value);
  };
  
  // Tahmin aralığı değişimi
  const handleRangeChange = (event) => {
    setForecastRange(event.target.value);
  };
  
  // Kategori değişimi
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };
  
  // Güven aralığı değişimi
  const handleConfidenceIntervalChange = (event) => {
    setConfidenceInterval(event.target.checked);
  };
  
  // Model yeniden eğit
  const handleTrainModel = () => {
    setIsTrainingModel(true);
    setModellingProgress(0);
    
    // İlerleme simülasyonu
    const interval = setInterval(() => {
      setModellingProgress((oldProgress) => {
        const newProgress = oldProgress + Math.random() * 10;
        if (newProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setIsTrainingModel(false);
          }, 500);
          return 100;
        }
        return newProgress;
      });
    }, 400);
  };
  
  // Gösterilecek ay sayısını belirleme
  const getMonthsToShow = () => {
    const pastMonths = 12; // Geçmiş 12 ay her zaman gösterilir
    
    // Tahmin aralığına göre gelecek ay sayısı
    let futureMonths = 6;
    if (forecastRange === '3month') futureMonths = 3;
    if (forecastRange === '6month') futureMonths = 6;
    if (forecastRange === '12month') futureMonths = 12;
    
    return { pastMonths, futureMonths };
  };
  
  // Verilerden görüntülenecek kısmı filtreleme
  const getFilteredData = () => {
    const { pastMonths, futureMonths } = getMonthsToShow();
    
    // Son pastMonths sayıda gerçek veri ve gelecek futureMonths sayıda tahmin
    const filtered = salesData.slice(24 - pastMonths, 24 + futureMonths);
    
    // Kategori filtreleri
    if (selectedCategory !== 'all') {
      return filtered.map(item => ({
        ...item,
        actual: item.actual ? item[selectedCategory] : null,
        forecast: item.forecast ? Math.round(item[selectedCategory] * (item.forecast / item.lower)) : null,
        upper: item.upper ? Math.round(item[selectedCategory] * (item.upper / item.lower)) : null,
        lower: item.lower ? item[selectedCategory] : null
      }));
    }
    
    return filtered;
  };
  
  // En iyi performans gösteren tahmin modeli
  const getBestModel = () => {
    return forecastModels.sort((a, b) => b.accuracy - a.accuracy)[0];
  };
  
  // Doğruluk gösterge rengi
  const getAccuracyColor = (accuracy) => {
    if (accuracy >= 95) return '#4caf50';
    if (accuracy >= 90) return '#8bc34a';
    if (accuracy >= 85) return '#ffeb3b';
    return '#ff9800';
  };
  
  // Kategori adı formatı
  const formatCategoryName = (category) => {
    if (category === 'electronics') return 'Elektronik';
    if (category === 'clothing') return 'Giyim';
    if (category === 'home') return 'Ev Ürünleri';
    if (category === 'other') return 'Diğer';
    return category;
  };
  
  // Para birimi formatı
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(value);
  };

  // Feature seçimi ve senaryo değişiklikleri için fonksiyonlar
  const handleScenarioChange = (scenarioId) => {
    if (scenarioId === 'custom') {
      setIsCustomScenario(true);
    } else {
      const scenario = forecastScenarios.find(s => s.id === scenarioId);
      if (scenario) {
        setSelectedScenario(scenarioId);
        setEnabledFeatures(scenario.features);
        setIsCustomScenario(false);
      }
    }
    setScenarioDialogOpen(false);
  };
  
  const handleFeatureToggle = (featureId) => {
    setEnabledFeatures(prev => {
      if (prev.includes(featureId)) {
        return prev.filter(id => id !== featureId);
      } else {
        return [...prev, featureId];
      }
    });
    setIsCustomScenario(true);
    setSelectedScenario('custom');
  };
  
  const handleFeatureDialogOpen = () => {
    setFeatureDialogOpen(true);
  };
  
  const handleFeatureDialogClose = () => {
    setFeatureDialogOpen(false);
  };
  
  const toggleComparisonMode = () => {
    setComparisonMode(!comparisonMode);
  };
  
  const handleComparisonScenarioChange = (event) => {
    setComparisonScenario(event.target.value);
  };

  // Karşılaştırma verisi için filtreleme
  const getFilteredComparisonData = () => {
    if (!comparisonData.length) return [];
    
    const { pastMonths, futureMonths } = getMonthsToShow();
    const filtered = comparisonData.slice(24 - pastMonths, 24 + futureMonths);
    
    if (selectedCategory !== 'all') {
      return filtered.map(item => ({
        ...item,
        actual: item.actual ? item[selectedCategory] : null,
        forecast: item.forecast ? Math.round(item[selectedCategory] * (item.forecast / (item.lower || 1))) : null,
        upper: item.upper ? Math.round(item[selectedCategory] * (item.upper / (item.lower || 1))) : null,
        lower: item.lower ? item[selectedCategory] : null
      }));
    }
    
    return filtered;
  };

  // Feature etkisini göster
  const getFeatureImpact = (feature) => {
    if (!salesData.length) return { value: 0, percentage: 0 };
    
    // Son 6 ayın verilerini al
    const recentData = salesData.slice(-18, -6);
    
    // Özelliğin toplam etkisini hesapla
    const totalImpact = recentData.reduce((sum, item) => {
      const featureEffect = item.features?.[feature] || 1.0;
      const impact = item.actual * (featureEffect - 1.0);
      return sum + impact;
    }, 0);
    
    // Toplam satışlara oranı
    const totalSales = recentData.reduce((sum, item) => sum + item.actual, 0);
    const percentage = (totalImpact / totalSales) * 100;
    
    return {
      value: Math.round(totalImpact),
      percentage: Math.round(percentage * 10) / 10
    };
  };

  // Feature etkilerini gösteren kart
  const renderFeatureImpactCard = () => {
    if (!salesData.length) return null;
    
    const featureImpacts = [
      { id: 'seasonality', name: 'Mevsimsellik', impact: getFeatureImpact('seasonality') },
      { id: 'promotion', name: 'Promosyonlar', impact: getFeatureImpact('promotion') },
      { id: 'event', name: 'Özel Günler', impact: getFeatureImpact('event') },
      { id: 'weather', name: 'Hava Durumu', impact: getFeatureImpact('weather') },
      { id: 'economic', name: 'Ekonomik Faktörler', impact: getFeatureImpact('economic') }
    ].sort((a, b) => b.impact.percentage - a.impact.percentage);
    
    return (
      <Paper sx={{ p: 3, borderRadius: 2, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Satışları Etkileyen Faktörler
        </Typography>
        <Grid container spacing={2}>
          {featureImpacts.map(feature => (
            <Grid item xs={12} sm={6} md={4} key={feature.id}>
              <Card sx={{ bgcolor: 'background.default', boxShadow: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    {feature.name}
                  </Typography>
                  <Typography variant="h5" color={feature.impact.percentage > 0 ? 'success.main' : 'error.main'}>
                    {feature.impact.percentage > 0 ? '+' : ''}{feature.impact.percentage}%
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {formatCurrency(feature.impact.value)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Button 
          startIcon={<TuneIcon />} 
          sx={{ mt: 2 }}
          onClick={handleFeatureDialogOpen}
        >
          Faktörleri Düzenle
        </Button>
      </Paper>
    );
  };
  
  // Feature seçim dialogu
  const renderFeatureDialog = () => (
    <Dialog 
      open={featureDialogOpen} 
      onClose={handleFeatureDialogClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Tahmin Modelini Özelleştir</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          Satış tahmininde kullanılacak veri özelliklerini seçin. Daha fazla özellik eklemek genellikle daha doğru tahminler sağlar, ancak model karmaşıklığını da artırır.
        </Typography>
        
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {salesFeatures.map(feature => (
            <Grid item xs={12} sm={6} key={feature.id}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enabledFeatures.includes(feature.id)}
                    onChange={() => handleFeatureToggle(feature.id)}
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1">{feature.name}</Typography>
                    <Typography variant="caption" color="text.secondary">{feature.description}</Typography>
                    <Chip 
                      size="small" 
                      label={feature.impact === 'high' ? 'Yüksek Etki' : feature.impact === 'medium' ? 'Orta Etki' : 'Düşük Etki'} 
                      color={feature.impact === 'high' ? 'success' : feature.impact === 'medium' ? 'primary' : 'default'}
                      sx={{ ml: 1, height: 20 }}
                    />
                  </Box>
                }
                sx={{ 
                  border: '1px solid', 
                  borderColor: 'divider', 
                  borderRadius: 1, 
                  p: 1, 
                  m: 0 
                }}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleFeatureDialogClose}>Kapat</Button>
        <Button 
          variant="contained" 
          color="primary"
          onClick={handleFeatureDialogClose}
        >
          Tahmin Modelini Güncelle
        </Button>
      </DialogActions>
    </Dialog>
  );
  
  // Senaryo seçim diyaloğu
  const renderScenarioDialog = () => (
    <Dialog
      open={scenarioDialogOpen}
      onClose={() => setScenarioDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Tahmin Senaryosu Seç</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          İhtiyaçlarınıza göre önceden yapılandırılmış bir tahmin senaryosu seçin veya kendi özel senaryonuzu oluşturun.
        </Typography>
        
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {forecastScenarios.map(scenario => (
            <Grid item xs={12} sm={6} key={scenario.id}>
              <Card 
                sx={{ 
                  cursor: 'pointer',
                  border: selectedScenario === scenario.id ? '2px solid' : '1px solid',
                  borderColor: selectedScenario === scenario.id ? 'primary.main' : 'divider',
                  height: '100%',
                  '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: 2
                  }
                }}
                onClick={() => handleScenarioChange(scenario.id)}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {scenario.name}
                    {selectedScenario === scenario.id && (
                      <DoneIcon color="primary" sx={{ ml: 1, fontSize: 20, verticalAlign: 'text-top' }} />
                    )}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {scenario.description}
                  </Typography>
                  <Typography variant="body2">
                    Doğruluk: <strong>{scenario.accuracy}%</strong>
                  </Typography>
                  <Box sx={{ mt: 1 }}>
                    {scenario.features.map(f => {
                      const feature = salesFeatures.find(sf => sf.id === f);
                      return feature ? (
                        <Chip 
                          key={f}
                          label={feature.name}
                          size="small"
                          sx={{ mr: 0.5, mb: 0.5 }}
                        />
                      ) : null;
                    })}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          
          {/* Özel senaryo kartı */}
          <Grid item xs={12} sm={6}>
            <Card 
              sx={{ 
                cursor: 'pointer',
                border: isCustomScenario ? '2px solid' : '1px solid',
                borderColor: isCustomScenario ? 'primary.main' : 'divider',
                height: '100%',
                bgcolor: 'background.default',
                '&:hover': {
                  borderColor: 'primary.main',
                  boxShadow: 2
                }
              }}
              onClick={() => handleScenarioChange('custom')}
            >
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Özel Senaryo
                  {isCustomScenario && (
                    <DoneIcon color="primary" sx={{ ml: 1, fontSize: 20, verticalAlign: 'text-top' }} />
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  İhtiyaçlarınıza uygun özel bir tahmin modeli oluşturun. İstediğiniz özellikleri seçebilirsiniz.
                </Typography>
                <Button 
                  variant="outlined" 
                  size="small" 
                  startIcon={<TuneIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFeatureDialogOpen();
                  }}
                >
                  Özellikleri Düzenle
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setScenarioDialogOpen(false)}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }} className="slide-in-left">
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Satış Tahminleme
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Geçmiş satış verilerinden faydalanarak gelecekteki satış performansını öngörün, eğilimleri tespit edin ve stratejik kararlar alın.
        </Typography>
        <Divider sx={{ my: 3 }} />
      </Box>

      {/* Yükleniyor durumu */}
      {loading && (
        <Box sx={{ width: '100%', my: 4 }}>
          <LinearProgress />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Satış tahmin verileri hazırlanıyor...
          </Typography>
        </Box>
      )}

      {!loading && (
        <>
          {/* Özet Kartlar */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Bu Ay Satışlar
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={summaryMetrics.currentMonthSales}
                          duration={1500}
                          formatter={(value) => formatCurrency(value)}
                        />
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#3f51b5', width: 48, height: 48 }}>
                      <StorefrontIcon />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Gelecek Ay Tahmini
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={summaryMetrics.nextMonthForecast}
                          duration={1500}
                          formatter={(value) => formatCurrency(value)}
                        />
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#4caf50', width: 48, height: 48 }}>
                      <TimelineIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
                    {parseFloat(summaryMetrics.growthRate) > 0 ? (
                      <>
                        <TrendingUpIcon color="success" fontSize="small" sx={{ mr: 0.5 }} />
                        <Typography variant="body2" color="success.main">
                          %{Math.abs(summaryMetrics.growthRate)} artış bekleniyor
                        </Typography>
                      </>
                    ) : (
                      <>
                        <TrendingDownIcon color="error" fontSize="small" sx={{ mr: 0.5 }} />
                        <Typography variant="body2" color="error.main">
                          %{Math.abs(summaryMetrics.growthRate)} azalış bekleniyor
                        </Typography>
                      </>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Tahmin Doğruluğu
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold" 
                        color={getAccuracyColor(parseFloat(summaryMetrics.forecastAccuracy))}>
                        <AnimatedNumber
                          value={parseFloat(summaryMetrics.forecastAccuracy)}
                          duration={1500}
                          suffix="%"
                        />
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#ff9800', width: 48, height: 48 }}>
                      <PrecisionManufacturingIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      {selectedModel} modeli ile
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        En Yüksek Satış Ayı
                      </Typography>
                      <Typography variant="h6" component="div" fontWeight="bold">
                        {summaryMetrics.highestMonth?.month} {summaryMetrics.highestMonth?.year}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {formatCurrency(summaryMetrics.highestMonth?.forecast)}
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#e91e63', width: 48, height: 48 }}>
                      <CalendarMonthIcon />
                    </Avatar>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Özellik ve Senaryo Seçim Araç Çubuğu */}
          <Paper sx={{ p: 2, borderRadius: 2, mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="body1" fontWeight="medium">
                Aktif Senaryo: {isCustomScenario ? 'Özel Senaryo' : forecastScenarios.find(s => s.id === selectedScenario)?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {enabledFeatures.length} özellik aktif • Tahmin Doğruluğu: ~{isCustomScenario ? '90-95' : forecastScenarios.find(s => s.id === selectedScenario)?.accuracy}%
              </Typography>
            </Box>
            <Box>
              <ButtonGroup variant="outlined" size="small">
                <Button 
                  startIcon={<FilterListIcon />}
                  onClick={() => setScenarioDialogOpen(true)}
                >
                  Senaryo Seç
                </Button>
                <Button 
                  startIcon={<TuneIcon />}
                  onClick={handleFeatureDialogOpen}
                >
                  Özellik Düzenle
                </Button>
                <Button 
                  startIcon={<CompareArrowsIcon />}
                  onClick={toggleComparisonMode}
                  color={comparisonMode ? "primary" : "inherit"}
                  variant={comparisonMode ? "contained" : "outlined"}
                >
                  Karşılaştır
                </Button>
              </ButtonGroup>
            </Box>
          </Paper>
          
          {/* Karşılaştırma seçenekleri */}
          {comparisonMode && (
            <Paper sx={{ p: 2, borderRadius: 2, mb: 3 }}>
              <Typography variant="subtitle1" gutterBottom>Senaryo Karşılaştırması</Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Karşılaştırılacak Senaryo</InputLabel>
                    <Select
                      value={comparisonScenario}
                      label="Karşılaştırılacak Senaryo"
                      onChange={handleComparisonScenarioChange}
                    >
                      {forecastScenarios.map(scenario => (
                        <MenuItem 
                          key={scenario.id} 
                          value={scenario.id}
                          disabled={selectedScenario === scenario.id}
                        >
                          {scenario.name} ({scenario.accuracy}%)
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ 
                      width: 12, 
                      height: 12, 
                      borderRadius: '50%', 
                      bgcolor: '#3f51b5', 
                      mr: 1 
                    }} />
                    <Typography variant="body2" sx={{ mr: 3 }}>
                      {isCustomScenario ? 'Özel Senaryo' : forecastScenarios.find(s => s.id === selectedScenario)?.name}
                    </Typography>
                    
                    <Box sx={{ 
                      width: 12, 
                      height: 12, 
                      borderRadius: '50%', 
                      bgcolor: '#f44336', 
                      mr: 1 
                    }} />
                    <Typography variant="body2">
                      {forecastScenarios.find(s => s.id === comparisonScenario)?.name}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          )}
          
          {/* Feature etkilerini gösteren kart */}
          {renderFeatureImpactCard()}

          {/* Ana içerik sekmeleri */}
          <Paper sx={{ borderRadius: 2, mb: 4 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab 
                label="Satış Tahminleri" 
                icon={<ShowChartIcon />} 
                iconPosition="start" 
              />
              <Tab 
                label="Kategori Analizi" 
                icon={<BarChartIcon />} 
                iconPosition="start" 
              />
              <Tab 
                label="Tahmin Modelleri" 
                icon={<AccountTreeIcon />} 
                iconPosition="start" 
              />
            </Tabs>
          </Paper>

          {/* Satış Tahminleri Sekmesi */}
          {activeTab === 0 && (
            <Grid container spacing={3}>
              <Grid item xs={12} lg={9}>
                <Paper 
                  sx={{ 
                    p: 3, 
                    borderRadius: 2, 
                    position: 'relative',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '4px',
                      background: 'linear-gradient(90deg, #3f51b5, #4caf50)',
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box>
                      <Typography variant="h6">
                        Satış Trendi ve Tahminleri
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Geçmiş satışlar ve gelecek aylar için tahminler
                      </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                      <FormControl sx={{ minWidth: 120 }} size="small">
                        <InputLabel>Tahmin Süresi</InputLabel>
                        <Select
                          value={forecastRange}
                          label="Tahmin Süresi"
                          onChange={handleRangeChange}
                        >
                          <MenuItem value="3month">3 Ay</MenuItem>
                          <MenuItem value="6month">6 Ay</MenuItem>
                          <MenuItem value="12month">12 Ay</MenuItem>
                        </Select>
                      </FormControl>
                      <IconButton size="small" sx={{ border: '1px solid #ddd' }}>
                        <FileDownloadIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </Box>
                  <Box sx={{ height: 450 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <ComposedChart
                        data={getFilteredData()}
                        margin={{ top: 10, right: 30, left: 20, bottom: 30 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <RechartsTooltip />
                        <Legend />
                        <defs>
                          <linearGradient id="colorForecast" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.1}/>
                            <stop offset="95%" stopColor="#8884d8" stopOpacity={0.1}/>
                          </linearGradient>
                        </defs>
                        {confidenceInterval && (
                          <Area 
                            type="monotone" 
                            dataKey="upper" 
                            stroke="transparent" 
                            fill="url(#colorForecast)" 
                            name="Güven Aralığı"
                          />
                        )}
                        {confidenceInterval && (
                          <Area 
                            type="monotone" 
                            dataKey="lower" 
                            stroke="transparent" 
                            fill="transparent" 
                            name=" "
                          />
                        )}
                        <Line 
                          type="monotone" 
                          dataKey="forecast" 
                          stroke="#8884d8" 
                          strokeWidth={2} 
                          strokeDasharray="5 5"
                          activeDot={false}
                          name="Tahmin"
                        />
                        <Line 
                          type="monotone" 
                          dataKey="actual" 
                          stroke="#4caf50" 
                          strokeWidth={2} 
                          dot={{ r: 4 }}
                          activeDot={{ r: 6 }}
                          name="Gerçekleşen"
                        />
                        
                        {/* Karşılaştırma modu aktif ise karşılaştırma verisi */}
                        {comparisonMode && comparisonData.length > 0 && (
                          <Line 
                            type="monotone" 
                            dataKey="forecast" 
                            data={getFilteredComparisonData()}
                            stroke="#f44336" 
                            strokeWidth={2} 
                            strokeDasharray="5 5"
                            activeDot={false}
                            name={`${forecastScenarios.find(s => s.id === comparisonScenario)?.name} Tahmini`}
                          />
                        )}
                        
                        <ReferenceLine x="Ara 2023" stroke="#ff9800" label="Şu An" />
                        <Brush dataKey="date" height={30} stroke="#8884d8" />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} lg={3}>
                <Stack spacing={3}>
                  <Paper sx={{ p: 3, borderRadius: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Model Ayarları
                    </Typography>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel>Tahmin Modeli</InputLabel>
                      <Select
                        value={selectedModel}
                        label="Tahmin Modeli"
                        onChange={handleModelChange}
                      >
                        {forecastModels.map(model => (
                          <MenuItem key={model.id} value={model.name}>
                            {model.name} ({model.accuracy}%)
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {/* Kategori seçimi */}
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel>Kategori</InputLabel>
                      <Select
                        value={selectedCategory}
                        label="Kategori"
                        onChange={handleCategoryChange}
                      >
                        <MenuItem value="all">Tüm Kategoriler</MenuItem>
                        <MenuItem value="electronics">Elektronik</MenuItem>
                        <MenuItem value="clothing">Giyim</MenuItem>
                        <MenuItem value="home">Ev Ürünleri</MenuItem>
                        <MenuItem value="other">Diğer</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Güven aralığı seçeneği */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={confidenceInterval}
                          onChange={handleConfidenceIntervalChange}
                          color="primary"
                        />
                      }
                      label="Güven Aralığını Göster"
                      sx={{ mb: 2 }}
                    />

                    {/* Model yeniden eğitme */}
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={isTrainingModel ? <CircularProgress size={20} color="inherit" /> : <InsightsIcon />}
                      disabled={isTrainingModel}
                      onClick={handleTrainModel}
                    >
                      {isTrainingModel ? 'Model Eğitiliyor...' : 'Modeli Yeniden Eğit'}
                    </Button>

                    {isTrainingModel && (
                      <Box sx={{ width: '100%', mt: 2 }}>
                        <LinearProgress variant="determinate" value={modellingProgress} />
                        <Typography variant="caption" align="center" display="block" sx={{ mt: 1 }}>
                          %{Math.round(modellingProgress)} tamamlandı
                        </Typography>
                      </Box>
                    )}

                    {/* Model bilgileri */}
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2" fontWeight="medium" gutterBottom>
                        Model Performansı
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Doğruluk:
                          </Typography>
                          <Typography variant="body2" fontWeight="bold">
                            %{forecastModels.find(m => m.name === selectedModel)?.accuracy || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            MAPE:
                          </Typography>
                          <Typography variant="body2" fontWeight="bold">
                            %{forecastModels.find(m => m.name === selectedModel)?.mape || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Eğitim Süresi:
                          </Typography>
                          <Typography variant="body2">
                            {forecastModels.find(m => m.name === selectedModel)?.trainingTime || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="text.secondary">
                            Karmaşıklık:
                          </Typography>
                          <Typography variant="body2">
                            {forecastModels.find(m => m.name === selectedModel)?.complexity || "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Paper>
                </Stack>
              </Grid>
            </Grid>
          )}

          {/* Kategori Analizi Sekmesi */}
          {activeTab === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Kategori Bazlı Satış Analizi ve Tahminler
                  </Typography>
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} lg={7}>
                      <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                          data={salesData.slice(-6).concat(salesData.slice(24, 30))}
                          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="date" />
                          <YAxis />
                          <RechartsTooltip />
                          <Legend />
                          <ReferenceLine y={0} stroke="#000" />
                          <Bar dataKey="electronics" name="Elektronik" stackId="a" fill={categoryColors.electronics} />
                          <Bar dataKey="clothing" name="Giyim" stackId="a" fill={categoryColors.clothing} />
                          <Bar dataKey="home" name="Ev Ürünleri" stackId="a" fill={categoryColors.home} />
                          <Bar dataKey="other" name="Diğer" stackId="a" fill={categoryColors.other} />
                        </BarChart>
                      </ResponsiveContainer>
                    </Grid>
                    
                    <Grid item xs={12} lg={5}>
                      <Box sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" gutterBottom>Kategori Performansı</Typography>
                        <Typography variant="body2" color="text.secondary" paragraph>
                          Son 6 ay ve gelecek 6 ay için kategori bazlı satış performansı. Elektronik ürünlerde güçlü büyüme trendi görülürken, giyim kategorisi mevsimsel dalgalanmalara daha duyarlı.
                        </Typography>
                      </Box>
                      
                      <Box>
                        <Typography variant="subtitle2" gutterBottom>Kategori Bazlı Büyüme Oranları (Yıllık)</Typography>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Kategori</TableCell>
                                <TableCell align="right">Büyüme</TableCell>
                                <TableCell align="right">Tahmini Gelir</TableCell>
                                <TableCell align="right">Kar Marjı</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: categoryColors.electronics, mr: 1 }} />
                                    Elektronik
                                  </Box>
                                </TableCell>
                                <TableCell align="right">+15.3%</TableCell>
                                <TableCell align="right">{formatCurrency(4250000)}</TableCell>
                                <TableCell align="right">18.2%</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: categoryColors.clothing, mr: 1 }} />
                                    Giyim
                                  </Box>
                                </TableCell>
                                <TableCell align="right">+9.7%</TableCell>
                                <TableCell align="right">{formatCurrency(3180000)}</TableCell>
                                <TableCell align="right">22.5%</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: categoryColors.home, mr: 1 }} />
                                    Ev Ürünleri
                                  </Box>
                                </TableCell>
                                <TableCell align="right">+7.2%</TableCell>
                                <TableCell align="right">{formatCurrency(2150000)}</TableCell>
                                <TableCell align="right">19.8%</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: categoryColors.other, mr: 1 }} />
                                    Diğer
                                  </Box>
                                </TableCell>
                                <TableCell align="right">+5.5%</TableCell>
                                <TableCell align="right">{formatCurrency(1250000)}</TableCell>
                                <TableCell align="right">15.3%</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                      
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle2" gutterBottom>Kategori Tavsiyeleri</Typography>
                        <Alert severity="info" sx={{ mb: 1 }}>
                          <Typography variant="body2">
                            <strong>Elektronik:</strong> Stok seviyelerini artırın, özellikle yeni model telefonlar ve akıllı ev cihazları için.
                          </Typography>
                        </Alert>
                        <Alert severity="success" sx={{ mb: 1 }}>
                          <Typography variant="body2">
                            <strong>Giyim:</strong> Kış koleksiyonu için erken sipariş verin, yıl sonu talebini karşılamak için stok oluşturun.
                          </Typography>
                        </Alert>
                        <Alert severity="warning">
                          <Typography variant="body2">
                            <strong>Ev Ürünleri:</strong> Düşen kar marjlarını iyileştirmek için tedarikçilerle görüşün veya premium ürün seçeneklerini artırın.
                          </Typography>
                        </Alert>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              
              {/* Kategori Detayları Accordion */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>Kategori Detayları</Typography>
                
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: categoryColors.electronics, mr: 1 }} />
                      <Typography>Elektronik Kategori Analizi</Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={8}>
                        <ResponsiveContainer width="100%" height={300}>
                          <LineChart
                            data={salesData.slice(-12).map(item => ({
                              ...item,
                              value: item.electronics,
                              forecast: item.forecast ? Math.round(item.electronics * (item.forecast / item.actual)) : null
                            }))}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <RechartsTooltip />
                            <Legend />
                            <Line type="monotone" dataKey="value" name="Gerçekleşen" stroke={categoryColors.electronics} />
                            <Line type="monotone" dataKey="forecast" name="Tahmin" stroke={categoryColors.electronics} strokeDasharray="5 5" />
                          </LineChart>
                        </ResponsiveContainer>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" gutterBottom>En Çok Satan Ürünler</Typography>
                        <List dense>
                          <ListItem>
                            <ListItemText primary="Akıllı Telefonlar" secondary="28% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Laptop ve Bilgisayarlar" secondary="22% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Akıllı Saatler" secondary="15% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Televizyonlar" secondary="12% kategori payı" />
                          </ListItem>
                        </List>
                        
                        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>Büyüme Tahmini</Typography>
                        <Typography variant="h5" color="success.main">+15.3%</Typography>
                        <Typography variant="body2" color="text.secondary">yıllık büyüme</Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: categoryColors.clothing, mr: 1 }} />
                      <Typography>Giyim Kategori Analizi</Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={8}>
                        <ResponsiveContainer width="100%" height={300}>
                          <LineChart
                            data={salesData.slice(-12).map(item => ({
                              ...item,
                              value: item.clothing,
                              forecast: item.forecast ? Math.round(item.clothing * (item.forecast / item.actual)) : null
                            }))}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <RechartsTooltip />
                            <Legend />
                            <Line type="monotone" dataKey="value" name="Gerçekleşen" stroke={categoryColors.clothing} />
                            <Line type="monotone" dataKey="forecast" name="Tahmin" stroke={categoryColors.clothing} strokeDasharray="5 5" />
                          </LineChart>
                        </ResponsiveContainer>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" gutterBottom>En Çok Satan Ürünler</Typography>
                        <List dense>
                          <ListItem>
                            <ListItemText primary="Tişörtler" secondary="25% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Pantolonlar" secondary="20% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Ceketler" secondary="18% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Ayakkabılar" secondary="15% kategori payı" />
                          </ListItem>
                        </List>
                        
                        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>Büyüme Tahmini</Typography>
                        <Typography variant="h5" color="success.main">+9.7%</Typography>
                        <Typography variant="body2" color="text.secondary">yıllık büyüme</Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 16, height: 16, borderRadius: 1, bgcolor: categoryColors.home, mr: 1 }} />
                      <Typography>Ev Ürünleri Kategori Analizi</Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* Ev ürünleri için benzer içerik */}
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={8}>
                        <ResponsiveContainer width="100%" height={300}>
                          <LineChart
                            data={salesData.slice(-12).map(item => ({
                              ...item,
                              value: item.home,
                              forecast: item.forecast ? Math.round(item.home * (item.forecast / item.actual)) : null
                            }))}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis />
                            <RechartsTooltip />
                            <Legend />
                            <Line type="monotone" dataKey="value" name="Gerçekleşen" stroke={categoryColors.home} />
                            <Line type="monotone" dataKey="forecast" name="Tahmin" stroke={categoryColors.home} strokeDasharray="5 5" />
                          </LineChart>
                        </ResponsiveContainer>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="subtitle2" gutterBottom>En Çok Satan Ürünler</Typography>
                        <List dense>
                          <ListItem>
                            <ListItemText primary="Mobilya" secondary="30% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Mutfak Eşyaları" secondary="25% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Aydınlatma" secondary="15% kategori payı" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="Banyo Ürünleri" secondary="10% kategori payı" />
                          </ListItem>
                        </List>
                        
                        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>Büyüme Tahmini</Typography>
                        <Typography variant="h5" color="success.main">+7.2%</Typography>
                        <Typography variant="body2" color="text.secondary">yıllık büyüme</Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
          )}

          {/* Tahmin Modelleri Sekmesi */}
          {activeTab === 2 && (
            <Grid container spacing={3}>
              <Grid item xs={12} lg={7}>
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Tahmin Modelleri Karşılaştırması
                  </Typography>
                  
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Model</TableCell>
                          <TableCell align="right">Doğruluk</TableCell>
                          <TableCell align="right">MAPE</TableCell>
                          <TableCell align="center">Kompleksite</TableCell>
                          <TableCell align="right">Eğitim Süresi</TableCell>
                          <TableCell align="center">Durum</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {forecastModels.map((model) => (
                          <TableRow 
                            key={model.id}
                            selected={model.name === selectedModel}
                            hover
                            onClick={() => setSelectedModel(model.name)}
                            sx={{ cursor: 'pointer' }}
                          >
                            <TableCell>
                              <Typography variant="body1" fontWeight={model.name === selectedModel ? 'bold' : 'normal'}>
                                {model.name}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Box sx={{ width: 40, mr: 1 }}>
                                  <LinearProgress 
                                    variant="determinate" 
                                    value={model.accuracy} 
                                    sx={{ 
                                      height: 8, 
                                      borderRadius: 1, 
                                      bgcolor: 'background.paper',
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: 
                                          model.accuracy >= 95 ? '#4caf50' : 
                                          model.accuracy >= 90 ? '#8bc34a' : 
                                          model.accuracy >= 85 ? '#ffeb3b' : 
                                          '#ff9800'
                                      }
                                    }} 
                                  />
                                </Box>
                                {model.accuracy}%
                              </Box>
                            </TableCell>
                            <TableCell align="right">{model.mape}%</TableCell>
                            <TableCell align="center">{model.complexity}</TableCell>
                            <TableCell align="right">{model.trainingTime}</TableCell>
                            <TableCell align="center">
                              <Chip 
                                label={model.name === selectedModel ? "Aktif" : "Pasif"} 
                                color={model.name === selectedModel ? "primary" : "default"}
                                size="small"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    * MAPE: Ortalama Mutlak Yüzde Hata (Mean Absolute Percentage Error)
                  </Typography>
                  
                  <Box sx={{ mt: 3 }}>
                    <Button 
                      variant="contained" 
                      color="primary"
                      startIcon={isTrainingModel ? <CircularProgress size={20} color="inherit" /> : <InsightsIcon />}
                      disabled={isTrainingModel}
                      onClick={handleTrainModel}
                    >
                      {isTrainingModel ? "Model Eğitiliyor..." : "Tüm Modelleri Yeniden Eğit"}
                    </Button>
                    
                    {isTrainingModel && (
                      <Box sx={{ width: '100%', mt: 2 }}>
                        <LinearProgress variant="determinate" value={modellingProgress} />
                        <Typography variant="caption" align="center" display="block" sx={{ mt: 1 }}>
                          %{Math.round(modellingProgress)} tamamlandı
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} lg={5}>
                <Paper sx={{ p: 3, borderRadius: 2, height: '100%' }}>
                  <Typography variant="h6" gutterBottom>
                    Model İyileştirme Önerileri
                  </Typography>
                  
                  <List>
                    <ListItemButton sx={{ borderRadius: 1, mb: 1, bgcolor: 'background.paper' }}>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>1</Avatar>
                      </ListItemIcon>
                      <ListItemText 
                        primary="Veri Kalitesini Artırın" 
                        secondary="Eksik veri noktalarını doldurun ve aykırı değerleri temizleyin. Bu, model doğruluğunu %2-3 artırabilir."
                      />
                    </ListItemButton>
                    
                    <ListItemButton sx={{ borderRadius: 1, mb: 1, bgcolor: 'background.paper' }}>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>2</Avatar>
                      </ListItemIcon>
                      <ListItemText 
                        primary="Daha Fazla Dış Faktör Ekleyin" 
                        secondary="Ekonomik göstergeler, hava durumu ve sosyal medya trendleri gibi dış faktörleri eklemek tahmin doğruluğunu iyileştirebilir."
                      />
                    </ListItemButton>
                    
                    <ListItemButton sx={{ borderRadius: 1, mb: 1, bgcolor: 'background.paper' }}>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>3</Avatar>
                      </ListItemIcon>
                      <ListItemText 
                        primary="Ensemble Modelleri Kullanın" 
                        secondary="Birden fazla tahmini birleştirmek, tek bir modele göre daha güvenilir sonuçlar verir."
                      />
                    </ListItemButton>
                    
                    <ListItemButton sx={{ borderRadius: 1, mb: 1, bgcolor: 'background.paper' }}>
                      <ListItemIcon>
                        <Avatar sx={{ bgcolor: 'primary.main' }}>4</Avatar>
                      </ListItemIcon>
                      <ListItemText 
                        primary="Gerçek Zamanlı Güncellemeler" 
                        secondary="Tahmin modelini günlük satış verileriyle düzenli olarak güncelleyin."
                      />
                    </ListItemButton>
                  </List>
                  
                  <Box sx={{ mt: 3 }}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      <Typography variant="subtitle2">En Yüksek Doğruluk</Typography>
                      <Typography variant="body2">
                        LSTM modeli, mevsimsel değişimler ve promosyon etkilerini en iyi şekilde yakalayarak en yüksek doğruluğu sağlıyor.
                      </Typography>
                    </Alert>
                    
                    <Alert severity="warning">
                      <Typography variant="subtitle2">En Hızlı Eğitim</Typography>
                      <Typography variant="body2">
                        ETS modeli hızlı eğitim süresine sahiptir, ancak doğruluk oranı daha düşüktür. Hızlı sonuçlar gerektiren durumlarda tercih edilebilir.
                      </Typography>
                    </Alert>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 2, mt: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Model Özellikleri ve Parametreler
                  </Typography>
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" gutterBottom>{selectedModel} Model Özellikleri</Typography>
                      
                      <TableContainer>
                        <Table size="small">
                          <TableBody>
                            <TableRow>
                              <TableCell width="30%" sx={{ fontWeight: 'bold' }}>Algoritma Tipi</TableCell>
                              <TableCell>{
                                selectedModel === 'ARIMA' ? 'Zaman Serisi Analizi' :
                                selectedModel === 'Prophet' ? 'Parçalı Zaman Serisi Analizi' :
                                selectedModel === 'LSTM' ? 'Derin Öğrenme' :
                                selectedModel === 'XGBoost' ? 'Gradient Boosting' :
                                selectedModel === 'ETS' ? 'Üstel Düzleştirme' : 'Bilinmiyor'
                              }</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Mevsimsellik Desteği</TableCell>
                              <TableCell>{
                                selectedModel === 'ARIMA' ? 'Orta' :
                                selectedModel === 'Prophet' ? 'Yüksek' :
                                selectedModel === 'LSTM' ? 'Yüksek' :
                                selectedModel === 'XGBoost' ? 'Düşük' :
                                selectedModel === 'ETS' ? 'Yüksek' : 'Bilinmiyor'
                              }</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Trend Desteği</TableCell>
                              <TableCell>{
                                selectedModel === 'ARIMA' ? 'Yüksek' :
                                selectedModel === 'Prophet' ? 'Yüksek' :
                                selectedModel === 'LSTM' ? 'Yüksek' :
                                selectedModel === 'XGBoost' ? 'Orta' :
                                selectedModel === 'ETS' ? 'Yüksek' : 'Bilinmiyor'
                              }</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Dış Faktör Desteği</TableCell>
                              <TableCell>{
                                selectedModel === 'ARIMA' ? 'Sınırlı' :
                                selectedModel === 'Prophet' ? 'Var' :
                                selectedModel === 'LSTM' ? 'Yüksek' :
                                selectedModel === 'XGBoost' ? 'Yüksek' :
                                selectedModel === 'ETS' ? 'Yok' : 'Bilinmiyor'
                              }</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Optimum Veri Uzunluğu</TableCell>
                              <TableCell>{
                                selectedModel === 'ARIMA' ? '2-3 Yıl' :
                                selectedModel === 'Prophet' ? '1-3 Yıl' :
                                selectedModel === 'LSTM' ? '3+ Yıl' :
                                selectedModel === 'XGBoost' ? '2+ Yıl' :
                                selectedModel === 'ETS' ? '1-2 Yıl' : 'Bilinmiyor'
                              }</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle1" gutterBottom>Güncel Model Performansı</Typography>
                      
                      <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item xs={6}>
                          <Paper sx={{ p: 2, bgcolor: 'primary.lighter', borderRadius: 2 }}>
                            <Typography variant="caption" color="primary.dark">Genel Doğruluk</Typography>
                            <Typography variant="h6" color="primary.dark">
                              {forecastModels.find(m => m.name === selectedModel)?.accuracy || "-"}%
                            </Typography>
                          </Paper>
                        </Grid>
                        <Grid item xs={6}>
                          <Paper sx={{ p: 2, bgcolor: 'error.lighter', borderRadius: 2 }}>
                            <Typography variant="caption" color="error.dark">Ortalama Hata (MAPE)</Typography>
                            <Typography variant="h6" color="error.dark">
                              {forecastModels.find(m => m.name === selectedModel)?.mape || "-"}%
                            </Typography>
                          </Paper>
                        </Grid>
                      </Grid>
                      
                      <Typography variant="subtitle2" gutterBottom>Model Performans Gelişimi</Typography>
                      <ResponsiveContainer width="100%" height={150}>
                        <LineChart
                          data={[
                            { month: 'Haz', accuracy: 88.2 },
                            { month: 'Tem', accuracy: 89.5 },
                            { month: 'Ağu', accuracy: 91.3 },
                            { month: 'Eyl', accuracy: 92.8 },
                            { month: 'Eki', accuracy: 93.5 },
                            { month: 'Kas', accuracy: 94.2 }
                          ]}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="month" />
                          <YAxis domain={[85, 100]} />
                          <RechartsTooltip />
                          <Line type="monotone" dataKey="accuracy" stroke="#8884d8" />
                        </LineChart>
                      </ResponsiveContainer>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}

          {/* Dialoglar */}
          {renderFeatureDialog()}
          {renderScenarioDialog()}
        </>
      )}
    </Container>
  );
};

export default SatisTahinleme;